import React from "react";
import * as Mui from "@mui/material";
import { FullPageModal } from "component/shared/full-page-modal";
import { ListingSearch } from "component/shared/listing-search";
import { User } from "model/user";
import { Lead } from "model/lead";
import { bindActionCreators } from "redux";
import { updateSavedListing, createSavedListing } from "redux/slice/saved-listings";
import { connect } from "react-redux";
import { SavedListing } from "model/saved-listing";

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	updateSavedListing,
	createSavedListing,
}, dispatch)

interface Props extends ReturnType<typeof mapDispatchToProps> {
	user: User;
	lead: Lead;
	open: boolean;
	onClose: Function;
	savedListings?: SavedListing[];
}

class Component extends React.Component<Props> {

	private save(listingId: string) {
		const { createSavedListing, lead } = this.props;
		createSavedListing({ savedListing: {
			lead,
			listing: { id: listingId },
		}});
	}

	private unsave(listingId: string) {
		const { updateSavedListing, savedListings } = this.props;
		if (savedListings) {
			savedListings.forEach(savedListing => {
				if (savedListing.listing && savedListing.listing.id === listingId) {
					updateSavedListing({ savedListing: {
						...savedListing,
						deleted: true,
					}});
				}
			});
		}
	}

	public render() {
		const { user, lead, open, onClose, savedListings } = this.props;
		const leadLabel = lead.name ? lead.name : lead.email;

		const actions = (
			<Mui.Button variant="contained" color="primary" onClick={() => onClose()}>
				Done
			</Mui.Button>
		);

		return (
			<FullPageModal
				open={open}
				onClose={() => onClose()}
				title="Add or Edit Saved Listings"
				leadName={leadLabel}
				actions={actions}
			>
				<ListingSearch
					user={user}
					onSaveListing={(listingId) => this.save(listingId)}
					onUnsaveListing={(listingId) => this.unsave(listingId)}
					savedListings={
						savedListings
							? savedListings
								.map(savedListing => savedListing.listing && savedListing.listing.id)
								.filter(Boolean) as string[]
							: []
					}
					hideSaveButton={true}
					disableRegistration={true}
					hideModal={true}
					nlsOverride={{
						enabled: user.naturalLanguageSearch,
						onlyMode: !!user.naturalLanguageSearch,
						showSavedSearches: false,
						showMarkets: false,
						showSuggestions: !!user.naturalLanguageSearch,
					}}
				/>
			</FullPageModal>
		);
	}
}

export const SaveListingDialog = connect(null, mapDispatchToProps)(Component);
